import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { CardType } from '../enums/card-type.enum';
import { IuguCard } from './iugu-card.model';

export class DisplayCard {
	id: string;
	brand: string;
	displayNumber: string;
	holderName: string;
	month: string;
	year: string;
	displayDate: string;
	// type: CardType;
	isSavedCard: boolean;

	constructor(obj: any = { }) {
		try {
			if (obj.extra_info || (obj.id && obj.data)) {
				const iuguCard: IuguCard = new IuguCard(obj);
				this.buildDisplayCard(iuguCard);
				this.isSavedCard = obj.extra_info == null; //IuguJS Credit Card
			} else {
				Object.assign(this, obj);

				// if (this.type != null && this.type['code'] == null) {
				// 	this.type = UtilHelper.getEnumByCod(this.type, CardType);
				// }
			}
		} catch (error) {
			Object.assign(this, obj);
		}
	}

	private buildDisplayCard(iuguCard: IuguCard): void {
		// this.type = CardType.CREDIT_CARD;
		this.id = iuguCard.id;
		this.brand = iuguCard.data.brand;
		this.displayNumber = iuguCard.data.display_number ? iuguCard.data.display_number.replace(/-/g, " ").replace(/X/g, "●") : "-";
		this.holderName = iuguCard.data.holder_name;
		this.month = iuguCard.data.month;
		this.year = iuguCard.data.year;
		this.displayDate = this.month + "/" + this.year; //this.getDisplayDate();
	}

	// private getDisplayDate(): string {
	// 	const date: Date = new Date();
	// 	date.setMonth(this.month - 1);
	// 	date.setFullYear(this.year);
	// 	return moment(date).format("MM/YYYY");
	// }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/card/display-card.model.ts